// extracted by css-extract-rspack-plugin
module.exports =  {"cardv4":"rg9Vl","topRow":"pfa9v","imgWrap":"XY5Cc","fit_contain":"Tej_Z","textWrap":"lRmtS","liveBtn":"FwRd1","gogoloader":"v56q7","socialShare_ss":"gG6vU"};